import React from 'react';
import { Box } from '@mui/material';
import useStartQuizStyles from '../../styles/perfectMatch/StartQuiz';

import logo from '../../assets/images/perfect_match/logo.jpg';
import bottlesImage from '../../assets/images/perfect_match/p1.jpg';
import promoalcool from '../../assets/images/promo-despre-alcool.png';

interface StartQuizProps {
    onStartQuiz: () => void;
}

const StartQuiz: React.FC<StartQuizProps> = ({ onStartQuiz }) => {
    const classes = useStartQuizStyles();

    return (
        <Box className={classes.container}>
            {/* Left Side - Full Height Image */}
            <Box className={classes.imageSection}>
                <img
                    src={bottlesImage}
                    alt="Kozel Premium and Dark bottles"
                    className={classes.bottlesImage}
                />
            </Box>

            {/* Right Side - Logo and Button */}
            <Box className={classes.contentSection}>
                <img
                    src={logo}
                    alt="Kozel Perfect Match"
                    className={classes.logoImage}
                />

                <button
                    onClick={onStartQuiz}
                    className={classes.startButton}
                >
                    Start Quiz
                </button>
                <img
                    src={promoalcool}
                    alt="Promo Alcool"
                    className={classes.logoImage}
                    style={{ marginTop: '2rem' }}
                />
            </Box>
        </Box>
    );
};

export default StartQuiz;